<template>
    <div class="Information">
        <dic class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Basic Info</h4>
                        <p>
                            <span class="bold">Family Name: </span>
                            <StringEditor v-bind:old-value="RecordData.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Family Name"
                                          property-name="Name"
                                          update-method="StrongFamilies/CommunityFamilies"
                                          v-bind:required="true"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Territory: </span>
                            <SelectEditor v-bind:old-value="RecordData.SubProgramTerritoryID"
                                          v-bind:old-value-text="RecordData.SubProgramTerritory.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Territory"
                                          property-name="SubProgramTerritoryID"
                                          update-method="StrongFamilies/CommunityFamilies"
                                          required="true"
                                          :options="SubProgramTerritoryOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                    </div>
                </div>

                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Physical Address</h4>
                        <AddressEditor v-bind:old-value="RecordData.PhysicalAddress"
                                       v-bind:record-id="RecordData.PhysicalAddress.Id"
                                       v-bind:edit-mode="EditMode"
                                       data-label="Physical Address"
                                       update-method="Core/Address/Update"
                                       required="true" />
                    </div>
                    
                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Mailing Address</h4>
                        <AddressEditor v-bind:old-value="RecordData.MailingAddress"
                                       v-bind:record-id="RecordData.MailingAddress.Id"
                                       v-bind:edit-mode="EditMode"
                                       data-label="Mailing Address"
                                       update-method="Core/Address/Update"
                                       required="false" />
                    </div>
                    
                </div>
            </div>
        </dic>
        
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission=""/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../../Core/ItemEditors/SelectEditor';
    import PersonEditor from '../../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';
    import AddressEditor from '../../../../Core/ItemEditors/AddressEditor.vue';
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            PersonEditor,
            EditMode,
            AddressEditor
        },
        mounted() {

        },
        computed: {
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            }
        }
    }
</script>

<style scoped>
</style>